import React from 'react';
import { Skeleton } from '@material-ui/lab';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';


import Breadcrumbs from '../../elements/Breadcrumbs';
import {
  BodyContainer,
  MobileCard,
  MobileCardDate,
  MobileCardTitle,
  MobileCardStatus,
  ColorStatusBlock,
  CloseIconBtn,
  MobileCardCloseIconBtn,
  HeaderRow,
} from './Appointments.style';
import moment from 'moment';
import { blue, grey, lightGray, mainGray, red } from '../../assets/ui/colors';
import useWindowDimensions from '../Lk/useWindowDimensions';
import CloseIcon from '../../assets/allIcons/CloseIcon';

const statuses = [{
  id: 0,
  label: 'Записан',
  color: grey
}, {
  id: 1,
  label: 'Выполнен',
  color: blue
}, {
  id: 2,
  label: 'Отменен',
  color: grey
}, {
  id: 3,
  label: 'Не выполнен',
  color: red
}, {
  id: 4,
  label: 'Записан',
  color: grey
}];

const AppointmentCard = ({ data, deleteAppointments }) => {
  return (
    <MobileCard>
      <HeaderRow>
        <MobileCardTitle>{data.researches[0] && data.researches[0].name || data.doctorInfo.specialization}</MobileCardTitle>
        <MobileCardCloseIconBtn>
          {data.status === 0 || data.status === 4
            ? <div onClick={() => deleteAppointments(data.id)}><CloseIcon /></div>
            : <div />}
        </MobileCardCloseIconBtn>
      </HeaderRow>
      {data.researchPlace}
      <MobileCardDate>
        {moment.parseZone(data.appointmentDateTime).format('DD.MM.YYYY, HH:mm')}
      </MobileCardDate>
      {data.recommendations}
      <MobileCardStatus color={statuses.find((item) => item.id === data.status).color}>
        {statuses.find((item) => item.id === data.status).label}
      </MobileCardStatus>
    </MobileCard>
  )
}

const Appointments = ({
  isLoading,
  appointments,
  deleteAppointments,
}) => {

  const windowWidth = useWindowDimensions().width;

  const StyledTableCell = withStyles((theme) => ({
    head: {
      fontSize: '14px',
      lineHeight: '16px',
      color: mainGray,
      background: lightGray,
      textTransform: 'uppercase',
    },
    body: {
      fontSize: '14px',
      lineHeight: '20px',
    },
  }))(TableCell);

  return (
    <>
      <Breadcrumbs pathArr={[{ label: 'Мои приемы' }]} />
      {appointments.length
        ? <BodyContainer>
          {windowWidth > 780
            ? isLoading
              ? <>
                <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
              </>
              : <Table aria-label="appointments table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Наименование</StyledTableCell>
                    <StyledTableCell align="left">Дата и время</StyledTableCell>
                    <StyledTableCell align="left">Адрес</StyledTableCell>
                    <StyledTableCell align="center">Рекомендации</StyledTableCell>
                    <StyledTableCell align="center">Статус</StyledTableCell>
                    <StyledTableCell align="center"></StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {appointments.map((row) => (
                    <TableRow key={row.id} hover>
                      <StyledTableCell component="th" scope="row" style={{ maxWidth: '180px' }}>
                        {row.researches[0] && row.researches[0].name || row.doctorInfo.specialization}
                      </StyledTableCell>
                      <StyledTableCell align="left" style={{ width: '110px' }}>{moment.parseZone(row.appointmentDateTime).format('DD.MM.YYYY, HH:mm')}</StyledTableCell>
                      <StyledTableCell align="left" style={{ maxWidth: '180px' }}>{row.researchPlace}</StyledTableCell>
                      <StyledTableCell align="left" component="th" scope="row">{row.recommendations}</StyledTableCell>
                      <StyledTableCell align="center" style={{ maxWidth: '100px', paddingRight: '30px' }}>
                        <ColorStatusBlock color={statuses.find((item) => item.id === row.status).color}>
                          {statuses.find((item) => item.id === row.status).label}
                        </ColorStatusBlock>
                      </StyledTableCell>
                      <StyledTableCell align="left" style={{ maxWidth: '180px', cursor: 'pointer' }} >{row.status === 0 || row.status === 4 ? <CloseIconBtn onClick={() => deleteAppointments(row.id)}>Отменить прием</CloseIconBtn> : <div />}</StyledTableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            : isLoading
              ? <>
                <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
              </>
              : <>
                {appointments.map((row) => (
                  <AppointmentCard data={row} key={row.id} deleteAppointments={deleteAppointments} />
                ))}
              </>
          }
        </BodyContainer>
        : <div>Здесь будет список ваших приемов</div>
      }
    </>
  )
}

export default Appointments;
